// declare var require: any;
// const data = require('../../env.json');
// export const environment = {
//   production: true,
//   clientId: data.clientId,
//   clientSecret: data.clientSecret,
//   apiUrl: data.apiUrl,
//   baseUrl: data.baseUrl,
//   languageUrl: data.languageUrl,
//   paymentUrl: data.paymentUrl,
//   paymentApiKey: data.paymentApiKey
// };

export const environment = {
  production: true,
  "apiUrl": "https://admin.betaspace.ltd/api/v1",
  "baseUrl": "https://betaspace.ltd",
  "clientId": "2",
  "clientSecret": "uo6s0m6tFycq7oli8vJm2sKEVB52XDbFScbyT1bF",
  "languageUrl": "https://admin.betaspace.ltd/uploads/language",
  "paymentUrl": "https://static.mul-pay.jp/ext/js/token.js",
  "paymentApiKey": "9200000460892"
};


